import { bigScreen_camera_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxCamera = {
  name: "cxCamera",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    bigScreen: [
      {
        name: "监控",
        children: bigScreen_camera_children
      }
    ]
  },
  toolbars: []
}

export default cxCamera
